function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

export { GrowthBook } from '@growthbook/growthbook';
import * as React from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var GrowthBookContext = /*#__PURE__*/React.createContext({});

function run(exp, growthbook) {
  if (!growthbook) {
    return {
      featureId: null,
      value: exp.variations[0],
      variationId: 0,
      inExperiment: false,
      hashUsed: false,
      hashAttribute: exp.hashAttribute || "id",
      hashValue: ""
    };
  }

  return growthbook.run(exp);
}

function feature(id, growthbook) {
  if (!growthbook) {
    return {
      value: null,
      on: false,
      off: true,
      source: "unknownFeature",
      ruleId: ""
    };
  }

  return growthbook.feature(id);
}

function useExperiment(exp) {
  var _React$useContext = React.useContext(GrowthBookContext),
      growthbook = _React$useContext.growthbook;

  return run(exp, growthbook);
}

function useFeature(id) {
  var _React$useContext2 = React.useContext(GrowthBookContext),
      growthbook = _React$useContext2.growthbook;

  return feature(id, growthbook);
}

function useGrowthBook() {
  var _React$useContext3 = React.useContext(GrowthBookContext),
      growthbook = _React$useContext3.growthbook;

  return growthbook;
}

function IfFeatureEnabled(_ref) {
  var children = _ref.children,
      feature = _ref.feature;
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}

function FeatureString(props) {
  var value = useFeature(props.feature).value;

  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.default);
}

var withRunExperiment = function withRunExperiment(Component) {
  // eslint-disable-next-line
  var withRunExperimentWrapper = function withRunExperimentWrapper(props) {
    return /*#__PURE__*/React.createElement(GrowthBookContext.Consumer, null, function (_ref2) {
      var growthbook = _ref2.growthbook;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        runExperiment: function runExperiment(exp) {
          return run(exp, growthbook);
        }
      }));
    });
  };

  return withRunExperimentWrapper;
};

withRunExperiment.displayName = "WithRunExperiment";

var GrowthBookProvider = function GrowthBookProvider(_ref3) {
  var children = _ref3.children,
      growthbook = _ref3.growthbook;

  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _ = _React$useState2[0],
      setRenderCount = _React$useState2[1];

  React.useEffect(function () {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(function () {
      setRenderCount(function (v) {
        return v + 1;
      });
    });
    return function () {
      growthbook.setRenderer(function () {// do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/React.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook: growthbook
    }
  }, children);
};

export { FeatureString, GrowthBookContext, GrowthBookProvider, IfFeatureEnabled, useExperiment, useFeature, useGrowthBook, withRunExperiment };